import { render } from "./addIndex.vue?vue&type=template&id=6e7ccf9e&scoped=true"
import script from "./addIndex.vue?vue&type=script&lang=js"
export * from "./addIndex.vue?vue&type=script&lang=js"

import "./addIndex.vue?vue&type=style&index=0&id=6e7ccf9e&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7ccf9e"]])

export default __exports__